import { put, select } from 'redux-saga/effects'

import { track as trackEvent } from '../../actions/tracking'
import { selectProduct } from '../../selectors/product'
import { selectCurrentCollectionIndex } from '../../selectors/ux'

function* onProductVideoStep(action) {
  const { params: { productId, step, seeked } } = action.payload

  const product = yield select(selectProduct(productId))
  const position = (yield select(selectCurrentCollectionIndex)) + 1 // from 1 to N

  yield put(trackEvent({
    event: 'viewedVideo',
    params: {
      step,
      seeked,
      id: product.id,
      title: product.title,
      position,
    },
  }))
}

export default onProductVideoStep
